import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getAllDeactivatedUsers(payload:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETALLDEACTIVEUSER}?start_date=${payload.startDate}&end_date=${payload.endDate}&page=${payload.pageNumber}&limit=${payload.pageSize}&search=${payload.search}`,
      callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDateWiseTeam(
  userId: string,
  from: string,
  to: string
) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLDEACTIVEUSER + `?id=${userId}&start_date=${from}&end_date=${to}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function postOfficeDetails() {
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeUserPassword(payload: any) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.EDITPASSWORD, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeStatusApi(status: any, userId: any) {
  const payload = {
    id: userId,
    status: status == 0 || status === "0" ? "1" : "0",
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.USERUPDATE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
